<template>
  <div class="main-header">
    <div class="logo-header">
      <img class="logo" src="@/assets/img/logo.svg" />
      <div class="logo-right">
        <span class="logo-logout logo-right--hover" @click="showOut()">{{ _("Exit") }}</span>
      </div>
    </div>
    <Out  :showInputDialog.sync="showOutDialog" ref="Out"  @change="showOut()" ></Out>

  </div>
</template>

<script>
import Out from "../../components/out.vue";

export default {
  components: { Out },
  props: {
  },
  data() {
    return {
      showOutDialog:false,
    };
  },
  methods: {
    showOut(){
      this.showOutDialog = !this.showOutDialog
    },

  }
};
</script>

<style lang="scss">
.menu {
  text-align: center;
}

.logo-header {
  padding-right: 24px;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0,21,41,0.12);
  @include flex-between();

  .logo {
    height: $header-height;
  }

  .logo-tips {
    display: inline-block;
    margin-left: 16px;
    vertical-align: top;
  }

  .logo-right {
    float: right;
    line-height: 20px;
    font-size: 12px;

    &--hover {
      margin-left: 24px;
      cursor: pointer;

      &:hover {
        color: $main-active-color;
      }
    }
  }
}
</style>
